/**
 * contextr.ts - Contextr (Context Management) preferences module
 * 
 * CHANGE HISTORY:
 * - 251031_1600 [pending] danielbeer: Initial creation
 */

export const contextrModule = {
  id: 'infra-contextr',
  name: 'Context Management',
  icon: '🎯',
  category: 'modules',
  order: 21,
  
  packageInfo: {
    name: '@opcentral/contextr',
    version: '0.2.0',
    displayVersion: '0.2.0',
    description: 'Context awareness & management for intelligent application behavior',
    status: 'active',
    implementationProgress: 100,
    dependencies: {
      '@opcentral/core': '*',
      'react': '^18.0.0'
    },
    keywords: ['context', 'awareness', 'state', 'management'],
    author: 'OpCentral Team',
    license: 'MIT'
  },
  
  settings: {
    enableContextTracking: {
      type: 'boolean',
      label: 'Enable Context Tracking',
      description: 'Track user context for intelligent behavior',
      defaultValue: true
    },
    
    contextDepth: {
      type: 'number',
      label: 'Context History Depth',
      description: 'Number of context states to remember',
      defaultValue: 10,
      min: 5,
      max: 50,
      visible: (settings) => settings['infra-contextr.enableContextTracking']
    },
    
    autoSaveContext: {
      type: 'boolean',
      label: 'Auto-Save Context',
      description: 'Automatically save context state',
      defaultValue: true
    }
  }
};

export default contextrModule;
